import type { TableFilterDropdownProps } from "../table-filter.type";

import { Input } from "antd";
import { useTranslation } from "react-i18next";

const TableFilterTextDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}: TableFilterDropdownProps) => {
  const { t } = useTranslation();

  return (
    <Input.Search
      allowClear
      autoFocus
      placeholder={t("global:search")}
      value={selectedKeys[0]}
      onKeyDown={(event) => event.stopPropagation()}
      onChange={(event) => {
        const value = event.target.value;
        setSelectedKeys(value ? [value] : []);
      }}
      // Triggered on icons click (search & clear) and when Enter key is pressed
      onSearch={(_value, _event, info) => {
        if (info?.source === "clear") clearFilters?.();
        confirm();
      }}
    />
  );
};

export default TableFilterTextDropdown;
